<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { Writable } from "svelte/store";
  import type { Field } from "svelte-forms2/types";

  type EventHandler = (e: Event) => void;
  type FormField = Omit<Writable<Field<string>>, "set"> & {
    validate: () => Promise<Field<string>>;
    reset: () => void;
    clear: () => void;
    set(this: void, value: string | Field<string>): void;
  };

  export let classes: string = "fizz-full-width fizz-flow-4 fizz-stack-16 fizz-inline-block";
  export let name: string = "email";
  export let id: string = name;
  export let field: FormField;
  export let label: string = "Email";
  export let labelClasses: string = "fizz-stack-8";
  export let onblur: EventHandler = (e: Event) => null;
  export let placeholder = "";
  export let testid: string = id;
  export let extraStyles: string = "";

  const dispatch = createEventDispatcher();

  const blur = (e: FocusEvent): void => {
    dispatch("blur", { target: e.currentTarget, field, fieldValue: $field });
    onblur(e);
  };

  const change = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("change", { target: e.currentTarget, field, fieldValue: $field });
  };

  const focus = (e: FocusEvent): void => {
    dispatch("click", { target: e.currentTarget, field, fieldValue: $field });
  };

</script>

<label class={classes} style={extraStyles}>
  <p class="fizz-label {labelClasses}"><strong>{label}</strong></p>
  <input
    {name}
    {id}
    {placeholder}
    class="fizz-input-text fizz-full-width"
    class:fizz-input-error={!$field.valid}
    data-testId={testid}
    type="email"
    bind:value={$field.value}
    on:blur={blur}
    on:change={change}
    on:focus={focus}
  />
  <slot />
</label>
